module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "geo-wrap"
  }, [_c('img', {
    ref: "southChinaSea",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "src": "//eagleeye.italent.cn/Images/south-china-sea.svg"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-053b4281!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/charts/china-map/index.vue
// module id = 224
// module chunks = 0